import React, { useState } from "react";
import styled from "styled-components";
import { P3Desk } from "../../styles/styles_text";
import { Card } from "../../components/ui/card";
import NewFilter from "../../assets/kinologyIcons/svg/new_filter.svg";
import WithFilter from "../../assets/kinologyIcons/svg/with_filter.svg";
import { Pie, PieChart, Sector } from "recharts";
import {
	ChartConfig,
	ChartContainer,
	ChartTooltip,
} from "../../components/ui/chart";
import SearchUsers from "./SearchUsers";
import Filter from "./Filter";

type Orientation = "horizontal" | "vertical";

interface DataShema {
	name_risco: string;
	valor_risco: string;
	fill: string;
	usuarios: any[];
}

interface DonutChartProps {
	orientation: Orientation;
	title: string;
	data: Array<DataShema> | [];
	onDonutChange: (selected: string[]) => void;
	defaultFilter: any;
}

const DonutChart: React.FC<DonutChartProps> = ({
	orientation,
	title,
	data,
	onDonutChange,
	defaultFilter,
}) => {
	const [isTooltipVisible, setIsTooltipVisible] = useState(false);

	const [with_filter, set_with_filter] = useState(false);
	const onFilterChange = (selected: any) => {
		const aux_filter = Object.entries(selected);
		set_with_filter(aux_filter.length > 0 ? true : false);
		onDonutChange(selected);
	};

	const chartConfig = {
		valor_risco: {
			label: "Visitors",
		},

		"Fora do padrão": {
			label: "Padrão esperado",
			color: "hsl(var(--chart-5))",
		},
	} satisfies ChartConfig;

	const [activeIndex, setActiveIndex]: any = useState(null);

	const renderActiveShape = ({ outerRadius = 0, ...props }: any) => (
		<Sector {...props} outerRadius={outerRadius + 5} />
	);

	function _renderDonut() {
		return (
			<ChartContainer
				onMouseLeave={() => setIsTooltipVisible(false)}
				config={chartConfig}
				className={"mx-auto w-full h-full min-h-[200px] min-w-[200px]"}
				style={{ zIndex: "0" }}
			>
				<PieChart width={150} height={150} style={{ zIndex: "1" }}>
					<ChartTooltip
						cursor={true}
						active={isTooltipVisible}
						content={<SearchUsers />}
						trigger={"click"}
					/>
					<Pie
						data={data}
						dataKey="valor_risco"
						nameKey="name_risco"
						innerRadius={55}
						onClick={() => setIsTooltipVisible(true)}
						activeIndex={activeIndex}
						activeShape={renderActiveShape}
						onMouseEnter={(_, index) => setActiveIndex(index)}
						onMouseLeave={() => setActiveIndex(null)}
					></Pie>
				</PieChart>
			</ChartContainer>
		);
	}
	function _renderLabel(color: string, percent: string, label: string) {
		return (
			<Card
				style={{
					border: "none",
					borderRadius: "8px",
					background: "white",
					boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.05)",
					display: "flex",
					alignItems: "center",
					width: orientation == "horizontal" ? "100%" : "80%",
					height: "2.81rem",
					gap: "1rem",
					margin: "0.4rem",
				}}
				onMouseEnter={() => setIsTooltipVisible(false)}
			>
				<Color
					style={{
						width: "0.5rem",
						height: "100%",
						backgroundColor: color,
						borderTopLeftRadius: "1rem",
						borderBottomLeftRadius: "1rem",
					}}
				/>

				<P3Desk
					style={{
						fontWeight: 600,
						color: "#1F2937",
						fontSize: "0.8rem",
					}}
				>
					{percent == "NaN%" ? "0%" : percent}
				</P3Desk>
				<P3Desk
					style={{
						color: "#6B7280",
						marginRight: "1rem",
						fontSize: "0.8rem",
					}}
				>
					{label}
				</P3Desk>
			</Card>
		);
	}

	const totalUsuarios = (data as any[]).reduce(
		(soma, item) => soma + item.usuarios.length,
		0
	);

	return (
		<Card
			style={{
				padding: "1rem",
				display: "flex",
				flexDirection: "column",
				backgroundColor: "#FFFFFF",
				width: orientation == "horizontal" ? "100%" : "32%",
				marginBottom: "0.75rem",
				marginTop: "0.75rem",
				position: "relative",
			}}
			onMouseEnter={() => setIsTooltipVisible(false)}
		>
			<P3Desk
				onMouseEnter={() => setIsTooltipVisible(false)}
				style={{
					textAlign: "center",
					paddingLeft: "2rem",
					paddingRight: "2rem",
				}}
			>
				{title}
			</P3Desk>

			<div style={{ position: "absolute", top: "1rem", right: "1rem" }}>
				<Filter
					icon={with_filter ? WithFilter : NewFilter}
					onFilterChange={onFilterChange}
					defaultFilter={defaultFilter}
					GraphType={title}
				/>
			</div>

			<div
				style={
					orientation == "horizontal"
						? {
							display: "flex",
							flexDirection: "row",
							justifyContent: "center",
							alignItems: "center",
						}
						: {
							display: "flex",
							flexDirection: "column",
						}
				}
			>
				<div>{_renderDonut()}</div>

				<div
					style={{
						display: "flex",
						flexDirection: "column",
						justifyContent: "center",
						alignItems: "center",
					}}
				>
					{data.map((item: any) =>
						_renderLabel(
							item?.fill,
							((item.valor_risco / totalUsuarios) * 100).toFixed(2) + "%",
							item?.name_risco
						)
					)}
					{ }
				</div>
			</div>
		</Card>
	);
};

const Color = styled.div``;

export default DonutChart;

